import { request } from "../../httpClient";

export const createVehicleRequest = async (values) => {
  const res = await request({
    path: "vehicle/set",
    method: "POST",
    body: values,
    requestType: null,
  });
  return res;
};
